<div class="row">
	<div class="col-12">
		<div class="panel">

			<h2>{{ labels().VIEW_CORRECTION_COMPONENT_TITLE }}</h2>

			<div class="row mt-5">
				<div class="col-4 open">
					<div class="wrapper-table-accordion d-block h-100 p-0">
						<vw-corr-mechanical [model]="model()" />
					</div>
				</div>
				<div class="col-8">
					@if (img()) {
					<img class="w-100" [src]="img()" alt="correction" style="height: fit-content;" />
					}
				</div>
			</div>

		</div>
	</div>

</div>